export default "__VITE_ASSET__4dda9222__"